<template>
    <div
    class="
        animate__animated animate__fadeIn animate__delay-1s
    "
    :class="[ type !== '' ? 'w-footer-block-inner' : 'w-footer-block px-0 pb-1' ]"
    >
        <div class="w-footer-logo">
            <object type="image/svg+xml" tabindex="-1" :data="require(`../../assets/images/gamelab.svg`)"></object>
        </div>
        <div class="w-chat-box" :class="[ (typeof visib !== 'undefined' && visib !== '') ? visib : '' ]" id="w-chat-box" @click="$root.$emit('live-chat-widget-visibility', 'show-hide');" v-if="pod_qr_support == ''">
            <!-- <span><i class="fa-brands fa-rocketchat"></i></span> -->
            <span tabindex="0"><img src="../../assets/images/chat-icon.png" alt="chat with us"></span>
        </div>
        <div class="w-chat-box" :class="[ (typeof visib !== 'undefined' && visib !== '') ? visib : '' ]" id="w-chat-box" v-if="pod_qr_support !== ''">
            <img :src="pod_qr_support" alt="chat with us" class="qr-support-image" @click="$root.$emit('live-chat-widget-visibility', 'show-hide');">
        </div>
    </div>
</template>
<script>
export default {
    name: "PlayerFooter-view",
    data() {
        return {
        };
    },
    computed: {
        pod_qr_support() {
            return this.$store.getters.getPodQRSupportImage();
        }
    },
    props: ['type', 'visib'],
    mounted() {
        this.$root.$on('show_hide_chat_icon', (message) => {
            if(message.type == 'show') {
                document.getElementById('w-chat-box').style.display = '';
            }
            else {
                document.getElementById('w-chat-box').style.display = 'none';
            }
        });
        // init pod qr support image
        this.$store.commit("setQrSupportUpater", true);
    }
}
</script>
<style scoped>
.w-chat-box {
    position: relative;
}
.w-chat-box .qr-support-image {
    /* position: absolute; */
    /* left: -110px;
    width: 100px;
    bottom: 0; */
    /* left: -105px;
    width: 100px;
    top: -110px; */
}
@media screen and (max-width:768px) {
    .w-chat-box .qr-support-image {
        /* bottom: 85px;
        left: 70px; */
        /* bottom: 0;
        left: -100px; */
    } 
}
</style>